module.exports = __webpack_public_path__ + "img/3_wind.22193fc5.jpg";